import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Allocation from '../components/Allocation';
import Loyalti from '../components/Loyalti';

const AppRouter = ({setT}) => {
  return (
    <Routes>
      <Route path="/" element={<Allocation setT={setT}/>} />
      <Route path="/referral" element={<Loyalti />} />
      <Route path="/ref/:code?" element={<Allocation setT={setT}/>} />
    </Routes>
  );
};

export default AppRouter;
